import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/charging_package_definitions',
  component: Management,
  redirect: '/charging_package_definitions/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/charging_package_definitions/List'),
      meta: {
        auth: Auth.listChargingPackageDefinitions
      },
      redirect: 'list/all',
      children: [
        {
          path: 'all',
          component: () => import('@/views/charging_package_definitions/ListTable'),
          meta: {
            auth: Auth.listChargingPackageDefinitions,
            tabName: 'all'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/charging_package_definitions/New'),
      meta: {
        auth: Auth.createChargingPackageDefinition
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/charging_package_definitions/Edit'),
      meta: {
        auth: Auth.updateChargingPackageDefinition
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/charging_package_definitions/DetailLayout'),
      meta: {
        auth: Auth.showChargingPackageDefinition
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/charging_package_definitions/details/Detail'),
          meta: {
            tabName: 'detail',
            auth: Auth.showChargingPackageDefinition
          }
        },
        {
          path: 'user_charging_packages',
          component: () => import('@/views/charging_package_definitions/details/UserChargingPackages'),
          meta: {
            tabName: 'user_charging_packages',
            auth: Auth.showChargingPackageDefinition
          }
        },
        {
          path: 'orders',
          component: () => import('@/views/charging_package_definitions/details/Orders'),
          meta: {
            tabName: 'orders',
            auth: Auth.showChargingPackageDefinition
          }
        },
        {
          path: 'product_orders',
          component: () => import('@/views/charging_package_definitions/details/ProductOrders'),
          meta: {
            tabName: 'product_orders',
            auth: Auth.showChargingPackageDefinition
          }
        }
      ]
    }
  ]
}
